export default __webpack_public_path__ + "static/media/blogmain.8618f11b.png";